import {
  BooleanInput,
  Edit,
  NumberInput,
  SimpleForm,
  TextInput,
  ReferenceInput,
  SelectInput,
} from 'react-admin';

export const ProductEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="article" fullWidth label="Артикуль" />
      <TextInput source="name" fullWidth label="Имя" />
      <TextInput source="description" fullWidth label="Описание" />
      <NumberInput source="price" fullWidth label="Цена" />
      <NumberInput source="count" fullWidth label="Количество" />
      <BooleanInput source="is_active" label="Активен" />
      <ReferenceInput
        source="category_id"
        reference="categories"
        label="Категория"
      >
        <SelectInput source="name" label="Категория" />
      </ReferenceInput>
    </SimpleForm>
  </Edit>
);
